<template>
    <div v-if="debugMode" class="flex">
        <div
            :class="otherClientsCount ? 'border-2 m-1 p-4 visible' : 'hidden'"
            :style="calculatedHeight"
            class="relative flex flex-col w-full overflow-hidden transition-height items-center justify-start rounded"
        >
            <button
                class="flex w-fit text-gray-600 text-xs font-bold items-center justify-center gap-2"
                @click="showOpenBaskets = !showOpenBaskets"
            >
                {{ otherClientsCount }} open
                {{ otherClientsCount > 1 ? 'baskets' : 'basket' }} at this table
                <span
                    class="size-3 bg-green-600 rounded-full animate-pulse inline-block"
                />
            </button>
            <ul
                v-if="otherClients.length"
                class="overflow-x-hidden w-full flex items-start mt-1 flex-col justify-start overflow-y-auto no-scrollbar"
            >
                <li
                    v-for="({ items, name }, clientIndex) in otherClients"
                    :key="`client-${clientIndex}`"
                    class="flex items-center min-h-14 w-full"
                >
                    <span class="text-nowrap text-sm text-gray-700">
                        {{ name }}:
                    </span>
                    <div
                        v-if="items.length"
                        class="flex gap-0.5 overflow-x-auto no-scrollbar ml-1.5"
                    >
                        <div
                            v-for="(item, itemIndex) in items"
                            :key="`item-${clientIndex}-${itemIndex}`"
                            class="relative flex-none size-10"
                        >
                            <cart-image
                                v-if="item.image"
                                :item="item"
                                class="scale-75 transform absolute -left-1 top-0"
                                size="1"
                            />
                            <div
                                class="absolute box-content border border-white text-xs size-[18px] transform scale-[80%] flex items-center justify-center bg-red-500 text-white rounded-full bottom-0 right-0"
                            >
                                {{ item.quantity }}
                            </div>
                        </div>
                    </div>
                    <div v-else class="ml-2 text-xs uppercase">
                        No items yet
                    </div>
                </li>
            </ul>
            <button @click="showOpenBaskets = !showOpenBaskets">
                <dropdown-icon
                    :class="showOpenBaskets ? 'rotate-180' : 'rotate-0'"
                    class="!size-4 bottom-0.5 absolute transform transition-transform duration-300"
                />
            </button>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CartImage from '@/components/elements/CartImage';
import DropdownIcon from '@/components/icons/DropdownIcon';

export default {
    name: 'TableOtherBaskets',

    components: {
        CartImage,
        DropdownIcon
    },

    data() {
        return {
            showOpenBaskets: false
        };
    },

    computed: {
        ...mapGetters({
            clients: 'ably/clients',
            members: 'ably/members',
            tableClientId: 'ably/tableClientId',
            otherClientsCount: 'ably/otherClientsCount',
            debugMode: 'helpers/isDebugMode'
        }),
        otherClients() {
            return Object.entries(this.clients || {})
                .filter(([key]) => key !== this.tableClientId)
                .map(([key, items], index) => {
                    const name = this.members?.find(
                        ({ clientId }) => clientId === key
                    )?.data.name;

                    return {
                        name: name || `Customer-${index}`,
                        items
                    };
                });
        },
        calculatedHeight() {
            const baseHeight = 56;

            if (!this.otherClientsCount) {
                return {
                    height: '0px'
                };
            }

            if (!this.showOpenBaskets) {
                return {
                    height: `${baseHeight}px`
                };
            }

            const maxRows = 4;
            const areMaxRowsExceeded = this.otherClientsCount > maxRows;
            const offset = areMaxRowsExceeded ? 35 : 0;
            const rows = areMaxRowsExceeded ? maxRows : this.otherClientsCount;
            const calculatedHeight = baseHeight + rows * baseHeight + offset;

            return {
                height: `${calculatedHeight}px`
            };
        }
    }
};
</script>
